// Product gallery slider: one main slide at a time, swipeable on touch, with
// thumbnail buttons that jump to a slide and highlight the slide in view.
class SProductGallery extends HTMLElement {
  #controller;
  #frame = 0;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    const track = this.querySelector('[data-gallery-track]');
    const thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
    if (!track || thumbs.length === 0) return;

    const behavior = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
    const direction = () => (getComputedStyle(track).direction === 'rtl' ? -1 : 1);

    for (const thumb of thumbs) {
      thumb.addEventListener(
        'click',
        () => {
          const index = Number(thumb.dataset.galleryThumb);
          track.scrollTo({ left: index * track.clientWidth * direction(), behavior: behavior() });
          this.#setActive(thumbs, index);
        },
        { signal },
      );
    }

    track.addEventListener(
      'scroll',
      () => {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => {
          const index = Math.round(Math.abs(track.scrollLeft) / Math.max(track.clientWidth, 1));
          this.#setActive(thumbs, Math.min(index, thumbs.length - 1));
        });
      },
      { passive: true, signal },
    );
  }

  #setActive(thumbs, index) {
    const strip = this.querySelector('[data-gallery-thumbs]');
    // Thumbs map to slides by data-gallery-thumb (the main image has no thumb, so array position ≠ slide index).
    thumbs.forEach((thumb) => thumb.setAttribute('aria-current', String(Number(thumb.dataset.galleryThumb) === index)));
    const active = thumbs.find((thumb) => Number(thumb.dataset.galleryThumb) === index);
    if (!strip || !active) return;
    const left = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2;
    strip.scrollTo({ left, behavior: 'auto' });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    cancelAnimationFrame(this.#frame);
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', SProductGallery);
